import {Nullable} from "../Common";

// The constant does not only contain the existing fields, but controls the summary column ordering.
export const departmentSummaryFields = [
  'epi_cost',
  'guarantee_cost',
  't1',
  'total_cost'
] as const;

export type DepartmentSummaryField = typeof departmentSummaryFields[number];

export type DepartmentSummaryResponse = Partial<Record<DepartmentSummaryField, Nullable<number>>>;

export const CustomDepartmentSummaryTitlesMap: Map<DepartmentSummaryField, string> = new Map([
  ['t1', 'T1 Cost']
]);